export {
  ResidentialAddress,
  IAddress,
  AUSTRALIA_COUNTRY_CODE,
} from './ResidentialAddress'
